import { createAsyncAction } from '../helpers';

export const feedbackCreateFeedbackAsyncAction =
	createAsyncAction('CREATE_FEEDBACK');
